module.exports = __webpack_public_path__ + "img/434C32_62704C_546244_2F3220-256px.1b1b25d0.png";